
import React, { useEffect, useState } from 'react';
import BookATour from '../NewComponents/sections/BookATour';
import { Header } from '../NewComponents/layout/Header';
import { FloatingBookButton } from '../NewComponents/ui/FloatingBookButton';
import { Footer } from '../NewComponents/layout/Footer';
import { VirtualHero } from '../NewComponents/sections/VirtualHero';
import MapSection from '../NewComponents/sections/MapSection';
import { FAQSection } from '../NewComponents/sections/FAQSection';
import WhatWeOffer from '../NewComponents/sections/WhatWeOffer';
import WhoItsFor from '../NewComponents/sections/WhoItsFor';
import TestimonialsSection from '../NewComponents/sections/TestimonialsSection';
import PricingPlan from '../NewComponents/sections/PricingPlan';
import { KeyBenifits } from '../NewComponents/sections/KeyBenifits';
import Popup from '../NewComponents/ui/Popup';
import { VirtualHeroPerungudi } from '../NewComponents/sections/VirtualHeroPerungudi';


const LandingPageVirtualPerungudi = () => {

    return (
        <div className="bg-white flex flex-col overflow-hidden items-center">
            <Header />
            <FloatingBookButton />
            <main>
                <div>
                    <VirtualHeroPerungudi />
                </div>
                <div>
                    <WhatWeOffer />
                </div>
                <div>
                    <KeyBenifits />
                </div>
                <div>
                    <WhoItsFor />
                </div>
                <div>
                    <PricingPlan />
                </div>

                <div>
                    <TestimonialsSection />
                </div>
                <div>
                    <FAQSection />
                </div>
                <div>
                    <MapSection />
                </div>
                <div className='w-[100vw]'>
                    <Footer />
                </div>
            </main>
        </div>
    );
};

export default LandingPageVirtualPerungudi;
